import React from "react";

export const EyeOffIcon = ({ width = 24, height = 24, color = "#000000", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M12 7.5C14.76 7.5 17 9.74 17 12.5C17 13.01 16.92 13.5 16.79 13.96L19.82 17C21.21 15.79 22.31 14.25 23 12.5C21.27 8.11 17 5 12 5C10.73 5 9.51 5.2 8.36 5.57L10.53 7.74C11 7.61 11.49 7.5 12 7.5ZM2.71 3.16C2.32 3.55 2.32 4.18 2.71 4.57L4.68 6.54C3.06 7.83 1.77 9.53 1 11.5C2.73 15.89 7 19 12 19C13.52 19 14.97 18.7 16.31 18.18L19.03 20.9C19.42 21.29 20.05 21.29 20.44 20.9C20.83 20.51 20.83 19.88 20.44 19.49L4.13 3.16C3.74 2.77 3.11 2.77 2.71 3.16ZM12 17.5C9.24 17.5 7 15.26 7 12.5C7 11.73 7.18 11 7.49 10.36L8.57 11.44C8.52 11.62 8.5 11.81 8.5 12C8.5 13.38 9.62 14.5 11 14.5C11.19 14.5 11.38 14.48 11.56 14.43L12.64 15.51C12.09 15.82 11.47 16 10.8 16C9.35 16 8.17 14.82 8.17 13.37C8.17 12.7 8.35 12.08 8.66 11.53L10.01 12.88C10.01 12.92 10 12.96 10 13C10 14.1 10.9 15 12 15C12.04 15 12.08 14.99 12.12 14.99L13.42 16.29C12.97 16.43 12.49 16.5 12 16.5Z"
        fill={color}
      />
    </svg>
  );
};
